import React, {createRef, useState, useContext} from 'react';
import {useQueryClient} from "react-query";
import {useAuth0} from "@auth0/auth0-react";
import axios from "axios";
import moment from "moment";
import __ from "lodash";
import { v4 as uuidv4 } from 'uuid';
import MaterialTable from "@material-table/core";
import {
  TablePagination,
  IconButton, Tooltip, Button, Icon, useTheme,
} from "@material-ui/core";
import PlayIcon from "@material-ui/icons/PlayCircleFilled";
import {getApiSitePrefix} from "../../../functions/SiteDefaults";
import SystemContext from "../../../SystemContext";
import { defaultComponents } from '../../../controls/Material-Table-Components';
import { ComboSelect, LightTooltip } from '../../../controls';
import { ValidatorColumn, ColumnWidth } from "../../../blocks/ColumnHelper";
import AirportNameTooltip from "../../Airports/components/AirportNameTooltip";
import FuelOrdersValidator from "../validators/FuelOrdersListValidator";
import MultiFlightSelectDialog from "./FuelOrderDialogs/MultiFlightSelectDialog";
import AddFuelOrderDialog from "./FuelOrderDialogs/AddFuelOrderDialog";
import SendFuelOrderDialog from "./FuelOrderDialogs/SendFuelOrderDialog";
import { useFuelOrders, useAddFuelOrder} from "../../../services/fuel";
import useColour, {getStatusColour} from '../../../services/settings/useColour';
import { getTemplate, getDefaultValues } from "../../../functions/TemplateHelperFunctions"


const apiSitePrefix = getApiSitePrefix();
const dateFormat = "DD/MM/YYYY";
const formatChars={
  "U": "[A-Z]",
  "A": "[A-Z0-9]",
  "a": "[A-Za-z0-9]",
  "i": "[A-Za-z0-9\\-]",
  "9": "[0-9]",
  "D": "[0-9.]",
  "-": "-",
  "x": "."
}


const FlightsMissingFuelOrdersList = (_props) => {
  const props = {
    ..._props
  }
  const {classes} = props;

  const {isAuthenticated} = useAuth0();
  const SystemData = useContext(SystemContext);
  const theme = useTheme();

  const [state] = useState({
    canEdit: props.canEdit,
  });
  const [addFuelDialogStates, setAddFuelDialogStates] = useState({
    showDialog: false,
    record: {},
    parentRecord: null,
    title: 'New Fuel Order'
  });
  const [sendFuelDialogStates, setSendFuelDialogStates] = useState({
    showDialog: false,
    record: {},
    parentRecord: null,
    title: 'Send Fuel Order'
  });
  const [confirmFlightSelection, setConfirmFlightSelection] = useState({
    showDialog: false,
    flights: {},
    airportCode: "",
    title: 'Confirm Flight Selection'
  });
  const [defaultValues, setDefaultValues] = useState({
    defaultTemplate: null,
    defaultAttachment: null,
  });
  const eventBus = SystemData.eventBus;

  const year = props.year;
  const month = props.month;
  const required = props.required;

  const tableRef = createRef({state: {lastEditingRow: false}});

  const handleAddFuelOrder = useAddFuelOrder();

  const queryClient = useQueryClient();
  const extraKeys = [year, month];
  if (required)
    extraKeys.push(true);

  const fuelOrders = useFuelOrders({tableRef, queryClient, extraKeys});

  const colours = useColour({code: "FUEL ORDERS TEXT"});
  const backgroundColours = useColour({code: "FUEL ORDERS BACKGROUND"});

  const refreshList = () => {
    queryClient.invalidateQueries(["FuelOrders", 0, 0, true]);
  }

  const getDefaultValues = async () => {
    try {
      const response = await axios.get(`${apiSitePrefix}/fuelorders/defaults`);
      if (response.data && response.data.success) {
        setDefaultValues(response.data.defaultValues);
        return response.data.defaultValues;
      }

      if (!response.data) {
        console.log(`Could not retrieve Fuel Order Defaults. Server is not responding`);
        SystemData.alert("Error", `Could not retrieve Fuel Order Template. Server is not responding`);
      } else if (!response.data.success) {
        console.log(`Could not retrieve Fuel Order Defaults. Server returned ${response.data.error}`);
        SystemData.alert("Error", `Could not retrieve Fuel Order Template. Server returned ${response.data.error}`);
      }
    } catch (err) {
      console.log(`Could not retrieve Fuel Order Defaults. Server is not responding`);
      SystemData.alert("Error", `Could not retrieve Fuel Order Template. Server is not responding`);
    }
  }

  // const handleNewOrder = async (rowData) => {
  //
  //   let defaults = {};
  //   if ( !defaultValues.defaultTemplate || !defaultValues.defaultAttachment) {
  //     defaults = await getDefaultValues(SystemData, "fuelorders", "Fuel Orders");
  //     if (!defaults)
  //       return;
  //   }
  //
  //   let tripLeg = null;
  //   let firstOrderLine = {};
  //   try {
  //     const response = await axios.get(`${apiSitePrefix}/triplegs/getTripLeg/${rowData.tripLegUuid}`);
  //     if (!response.data) {
  //       SystemData.alert("Error", `Could not retrieve flight information. Server is not responding`);
  //     } else if (response.data && Array.isArray(response.data) && response.data.length > 0) {
  //       tripLeg = response.data[0];
  //     } else {
  //       SystemData.alert("Error", `Could not retrieve flight information. Server could not find the flight`);
  //     }
  //   } catch (error) {
  //     SystemData.alert("Error", `Could not retrieve flight information. Server is not responding`);
  //   }
  //
  //   let fuelSupplierUuid = null;
  //   if (tripLeg) {
  //     const tripLegServices = await fetchTripLegServices({queryClient, extraKeys: [tripLeg.tripLegUuid], useCache: false});
  //     if (tripLegServices && Array.isArray(tripLegServices) && tripLegServices.length > 0) {
  //       const fuelService = __.filter(tripLegServices, {serviceCode: "FUELING"});
  //       if (fuelService && Array.isArray(fuelService) && fuelService.length > 0) {
  //         fuelSupplierUuid = fuelService[0].serviceProviderUuid;
  //       }
  //     }
  //
  //     firstOrderLine =
  //     {
  //       tripLegUuid: tripLeg.tripLegUuid,
  //       reference: `${tripLeg.airlineCode}${tripLeg.flightNo}-${moment.utc(tripLeg.scheduledDepartureTimeUTC).format("MMDD")}`,
  //       locationAirportCode: tripLeg.originAirportCode,
  //       destinationAirportCode: tripLeg.destinationAirportCode,
  //       airlineCode: tripLeg.airlineCode,
  //       flightNo: tripLeg.flightNo,
  //       flightNumber: `${tripLeg.airlineCode}${tripLeg.flightNo}`,
  //       aircraftType: "B747F",
  //       aircraftTailNumber: tripLeg.aircraftId,
  //       arrivalDate: moment.utc(tripLeg.previousScheduledArrivalTimeUTC).format("YYYY-MM-DD"),
  //       scheduledArrivalTimeUTC: moment.utc(tripLeg.previousScheduledArrivalTimeUTC).format("HH:mm"),
  //       departureDate: moment.utc(tripLeg.scheduledDepartureTimeUTC).format("YYYY-MM-DD"),
  //       scheduledDepartureTimeUTC: moment.utc(tripLeg.scheduledDepartureTimeUTC).format("HH:mm"),
  //       fuelPolicy: "SECTOR",
  //     }
  //   }
  //
  //   const newFuelOrderTemplate = {
  //     fuelOrderUuid: uuidv4(),
  //     airportCode: rowData.originAirportCode,
  //     orderDate: moment().format("YYYY-MM-DD HH:mm:ss"),
  //     lines:[firstOrderLine],
  //     status: "REQUIRED",
  //     tripNo: null,
  //     fuelOrderTemplateUuid: rowData.orderTemplate || defaults.defaultTemplate,
  //     attachmentUuid: defaultValues.defaultAttachment || defaults.defaultAttachment,
  //     fuelPolicy: "SECTOR",
  //     fuelSupplierUuid: fuelSupplierUuid ?? undefined,
  //   }
  //   setAddFuelDialogStates({...addFuelDialogStates, showDialog: true, record: {...(__.cloneDeep(newFuelOrderTemplate))}, parentRecord: null, title: 'New Fuel Order'});
  // }

  const handlePreSelectedFlights = async (selectedRecords, fuelPolicy, fuelSupplierUuid, supplyDetails) => {
    let records = Array.isArray(selectedRecords) ? selectedRecords : [selectedRecords];
    const firstRecord = __.cloneDeep(records[0]);

    let defaults = {};
    if ( !defaultValues.defaultTemplate || !defaultValues.defaultAttachment) {
      defaults = await getDefaultValues(SystemData, "fuelorders", "Fuel Orders");
      if (!defaults)
        return;
    }
    const newFuelOrderTemplate = {
      fuelOrderUuid: uuidv4(),
      airportCode: firstRecord.locationAirportCode,
      orderDate: moment().format("YYYY-MM-DD HH:mm:ss"),
      lines:selectedRecords,
      status: "REQUIRED",
      tripNo: null,
      fuelOrderTemplateUuid: defaultValues.defaultTemplate || defaults.defaultTemplate,
      attachmentUuid: defaultValues.defaultAttachment || defaults.defaultAttachment,
      fuelPolicy: fuelPolicy,
      fuelSupplierUuid: firstRecord.fuelSupplierUuid ?? undefined,
      supplyDetails: supplyDetails,
      companyName: firstRecord.companyName
    }
    setAddFuelDialogStates({...addFuelDialogStates, showDialog: true, record: {...(__.cloneDeep(newFuelOrderTemplate))}, parentRecord: null, title: 'New Fuel Order'});
  }

  const handleNewOrders = async (selectedRecords) => {
    let records = Array.isArray(selectedRecords) ? selectedRecords : [selectedRecords];
    const firstRecord = __.cloneDeep(records[0]);
    records = __.filter(records, {originAirportCode: firstRecord.originAirportCode, serviceProviderUuid: firstRecord.serviceProviderUuid});

    let defaults = {};
    if ( !defaultValues.defaultTemplate || !defaultValues.defaultAttachment) {
      defaults = await getDefaultValues(SystemData, "fuelorders", "Fuel Orders");
      if (!defaults)
        return;
    }

    let lines = [];
    records.forEach(record => {
      const line =
        {
          tripLegUuid: record.tripLegUuid,
          reference: `${record.airlineCode}${record.flightNo}-${moment.utc(record.scheduledDepartureTimeUTC).format("MMDD")}`,
          locationAirportCode: record.originAirportCode,
          destinationAirportCode: record.destinationAirportCode,
          airlineCode: record.airlineCode,
          flightNo: record.flightNo,
          flightNumber: `${record.airlineCode}${record.flightNo}`,
          aircraftType: "B747F",
          aircraftTailNumber: record.aircraftId,
          arrivalDate: moment.utc(record.previousScheduledArrivalTimeUTC).format("YYYY-MM-DD"),
          scheduledArrivalTimeUTC: moment.utc(record.previousScheduledArrivalTimeUTC).format("HH:mm"),
          departureDate: moment.utc(record.scheduledDepartureTimeUTC).format("YYYY-MM-DD"),
          scheduledDepartureTimeUTC: moment.utc(record.scheduledDepartureTimeUTC).format("HH:mm"),
          fuelPolicy: "SECTOR",
          companyName: record.companyName,
          serviceProviderUuid: record.serviceProviderUuid,
        }
        lines.push(line);
    });

    if (lines.length > 1) {
      setConfirmFlightSelection({showDialog: true, flights: lines, airportCode: firstRecord.originAirportCode});
      if (eventBus) {
        const params = { title: "Confirm Flights to add to Order", canEdit: true }
        eventBus.trigger('FlightListLookup.open', params);
      }
    } else {
      let fuelSupplierUuid = firstRecord.serviceProviderUuid;
      const newFuelOrderTemplate = {
        fuelOrderUuid: uuidv4(),
        airportCode: firstRecord.originAirportCode,
        orderDate: moment().format("YYYY-MM-DD HH:mm:ss"),
        lines:lines,
        status: "REQUIRED",
        tripNo: null,
        fuelOrderTemplateUuid: firstRecord.orderTemplate || defaults.defaultTemplate,
        attachmentUuid: defaultValues.defaultAttachment || defaults.defaultAttachment,
        fuelPolicy: "SECTOR",
        fuelSupplierUuid: fuelSupplierUuid ?? undefined,
        companyName: firstRecord.companyName        
      }
      setAddFuelDialogStates({...addFuelDialogStates, showDialog: true, record: {...(__.cloneDeep(newFuelOrderTemplate))}, parentRecord: null, title: 'New Fuel Order'});
    }
  }

  const closeAddFuelOrder = () => {
    setAddFuelDialogStates({
      ...addFuelDialogStates,
      showDialog: false,
      record: {},
      parentRecord: null,
      title: 'New Fuel Order'
    });
    queryClient.invalidateQueries(["FuelOrders", "Count", 0, 0, true]);
    queryClient.invalidateQueries(["FuelOrders", "Count", 0, 0, "cancelled"]);
  }

  const handleSendOrderClick = async (rowData) => {
    let defaults = {};
    if ( !defaultValues.defaultTemplate || !defaultValues.defaultAttachment) {
      defaults = await getDefaultValues(SystemData, "fuelorders", "FuelOrder");
      setDefaultValues(defaults);
    }

    const firstDepartureDate = rowData?.lines && Array.isArray(rowData.lines) && rowData.lines.length > 0? rowData.lines[0].departureDate : null;
    const month = firstDepartureDate ? moment(firstDepartureDate, "YYYY-MM-DD") : moment();
    const fuelOrderSubject = `Magma Aviation Fuel Request // ${rowData.airportCode} // ${month.format("MMM-YYYY")}`;
    if (rowData.orderTemplate === undefined) {
      const template = await getTemplate( SystemData, "fuelorders", "Fuel Order", "order", rowData.fuelOrderTemplateUuid);
      // getTemplate will popup an alert if it cannot get a template, so no point in going further
      if (!template)
        return;
      rowData["orderTemplate"] = template;
    }
    if (rowData.orderTemplate) {
      const newFuelOrderTemplate = {
        ...rowData,
        orderDate: moment().format("YYYY-MM-DD HH:mm:ss"),
        fuelOrderSubject,
        carbonCopy: defaultValues && __.has(defaultValues, "ccList") ? defaultValues.ccList : defaults.ccList,
      }
      const title = `Send Fuel Order${rowData ? " to '" + rowData.companyName + "'":""}${rowData.airportCode ? " at '" + rowData.airportCode + "'": ""}`;
      setSendFuelDialogStates({...sendFuelDialogStates, showDialog: true, record: {...(__.cloneDeep(newFuelOrderTemplate))}, parentRecord: null, title: title});
    }
  }

  const closeSendFuelOrder = () => {
    setSendFuelDialogStates({
      ...addFuelDialogStates,
      showDialog: false,
      record: {},
      parentRecord: null,
      title: 'Send Fuel Order'
    });
  }

  const selectionAllowed = (rowData) => {
    if (tableRef.current) {
      const data = tableRef.current.dataManager.data;
      if (data && Array.isArray(data)) {
        let selectedAirport = null;
        let supplierUuid = null;
        let status = null;
        for (let i = 0; i < data.length; i++) {
          const item = data[i];
          if (__.has(item.tableData, "checked") && item.tableData.checked) {
            selectedAirport = item.originAirportCode;
            supplierUuid = item.serviceProviderUuid;
            status = item.indicatorStatus;
            break;
          }
        }
        if (selectedAirport)
          return (rowData.originAirportCode === selectedAirport && rowData.serviceProviderUuid === supplierUuid);
      }
      return true;
    }
  }


  const getColumns = (props) => {
    const validatorColumn = ValidatorColumn(FuelOrdersValidator, true);

    const baseColumn = {
      cellStyle: { fontSize:12, padding: "4px 2px" },
      headerStyle: { padding: "4px 2px" },
      editable: props.canEdit ? "always" : "never",
      emptyValue: "",
      initialEditValue: "",
      sorting: false
    };

    const defaultEditProps = {
      style:{fontSize: "0.875rem"}
    };

    return [
      {...validatorColumn},
      /*
        Can use ...ColumnWidth(70) to generate a fixed width column
      */

      {
        ...baseColumn,
        ...(ColumnWidth(110, [10,10], undefined, {paddingLeft: 12}, {paddingLeft: 12})),
        title: "At Airport",
        field: "originAirportCode",
        initialEditValue: "",
        sorting: true,
        editable: "never",
        render: (rowData) => (
          <LightTooltip title={<AirportNameTooltip airportCode={rowData.originAirportCode} />}>
            <span> {rowData.originAirportCode} </span>
          </LightTooltip>
        ),
      },
      // {
      //   ...baseColumn,
      //   ...(ColumnWidth(130, undefined, undefined, {paddingLeft: 12}, {paddingLeft: 12})),
      //   title: "Status",
      //   field: "indicatorStatus",
      //   editable:  "never",
      //   fullWidth: true,
      //   sorting: true,
      //   cellStyle: (value, rowData) => {
      //     const backgroundColor = getStatusColour(backgroundColours, value);
      //     const color = getStatusColour(colours, value);
      //     const {cellStyle} = ColumnWidth(100);
      //     return ({...cellStyle, color, backgroundColor, textAlign: "center", border: `1px solid #d0d0d0`, fontWeight: 600});
      //   },
      //   render: rowData => (
      //     <ComboSelect
      //       group="FUEL ORDER STATUS"
      //       subGroup=""
      //       value={rowData.indicatorStatus}
      //       displayOnly={true}
      //     />
      //   ),
      // },
      {
        ...baseColumn,
        ...ColumnWidth(120,[10,10],undefined,undefined,undefined,undefined,false),
        title: "Flight Number",
        field: "flightNo",
        render: (props) => (
          <div style={{ width: 162 }}>
            {props.airlineCode}&nbsp;{props.flightNo}
          </div>
        ),
      },
      {
        ...baseColumn,
        ...(ColumnWidth(100, undefined, undefined, undefined, undefined)),
        title: "Flight Date",
        field: "scheduledDepartureTimeUTC",
        editable: "never",
        customFilterAndSearch: (term, rowData) => {
          const searchDate = moment.utc(rowData.scheduledDepartureTimeUTC).startOf('day').format('DD MMM YYYY').toUpperCase();
          const termUpper = `${term}`.toUpperCase();
          return searchDate.indexOf(termUpper) !== -1
        },
        render: rowData => {
          const displayDate = rowData.scheduledDepartureTimeUTC ? moment.utc(rowData.scheduledDepartureTimeUTC).format(dateFormat) : "Not Sent Yet";
          return (<div>{displayDate}</div>);
        },
      },
      {
        ...baseColumn,
        ...(ColumnWidth(120, undefined, undefined, undefined, undefined)),
        title: "Departure Time",
        field: "scheduledDepartureTimeUTC",
        render: rowData => (
          <div>{rowData.scheduledDepartureTimeUTC ? moment.utc(rowData.scheduledDepartureTimeUTC).format("HH:mm") : ""}</div>
        ),
      },
      {
        ...baseColumn,
        title: "Fuel Supplier",
        field: "serviceProviderUuid",
        render: rowData => ( rowData.companyName ),
      },
      {
        ...baseColumn,
        ...(ColumnWidth(10,)),
      },
    ];
  };

  return (isAuthenticated &&
    <div style={{width: "100%", marginLeft: 20, marginRight: 20}}>
      <MaterialTable
        tableRef={tableRef}
        style={{
          border: "none",
          boxShadow: "none",
          borderRadius: 0,
        }}
        options={{
          addRowPosition: "first",
          actionsColumnIndex: -1,
          cellStyle: {
            padding: "8px 2px",
          },
          headerStyle: {
            backgroundColor: theme.palette.tableHeader.backgroundColor,
            color: theme.palette.tableHeader.textColor,
            padding: "2px",
          },
          toolbarButtonAlignment: "right",
          pageSize: 15,
          detailPanelType: "single",
          padding: "dense",
          //overflowY: "scroll",
          selection: state.canEdit,
          selectionProps: rowData => ({
            disabled: !selectionAllowed(rowData),
            color: "primary"
          })
        }}
        components={{
          ...defaultComponents,
          Pagination: (props) => (
            <TablePagination
              {...props}
              rowsPerPageOptions={[5, 10, 15]}
            />
          ),
          Action: _props => {
            let props = {..._props};
            if (typeof props.action.action === "function") {
              props.action = {..._props.action, ..._props.action.action(_props.data)};
            }
            if (props.action.icon==="generate") {
              return (
                <Tooltip title={props.action.tooltip}>
                  <Button
                    style={{height: 24}}
                    variant="contained"
                    color="primary"
                    startIcon={<PlayIcon/>}
                    className={classes.button}
                    onClick={() => {
                      props.action.onClick(props.data)
                    }}
                  >
                    {props.action.text}
                  </Button>
                </Tooltip>
              )
            } else if (props.action.icon) {
              if (props.action.tooltip) {
                return (<Tooltip title={props.action.tooltip}><IconButton {...__.pick(props.action, ['onClick', 'style', 'color', 'disabled'])}><Icon>{props.action.icon}</Icon></IconButton></Tooltip>)
              }
              return (<IconButton {...__.pick(props.action, ['onClick', 'style', 'color', 'disabled'])}><Icon>{props.action.icon}</Icon></IconButton>)
            } else {
              return (<></>)
            }
          }
        }}
        actions={[
          {
            icon: 'refresh',
            tooltip: "Refresh List",
            isFreeAction: true,
            onClick: refreshList
          },
          (rowData) => ({
            icon: "generate",
            text: "Generate",
            tooltip: "Create fuel order for the flight",
            onClick: handleNewOrders,
            disabled: !state.canEdit
          }),
        ]}
        title="Flights Missing Fuel Orders"
        columns={getColumns({canEdit: state.canEdit})}
        data={fuelOrders.data}
        editable={{
          isEditable: () => {
            return state.canEdit;
          },
          isDeletable: () => {
            return state.canEdit;
          },
          onRowAdd: undefined,
          onRowUpdate: undefined,
          onRowDelete: undefined,
        }}
      />

      {addFuelDialogStates.showDialog
        ?
          <AddFuelOrderDialog
            dialogStates={addFuelDialogStates}
            SystemData={SystemData}
            extraKeys={extraKeys}
            handleAdd={handleAddFuelOrder}
            formatChars={formatChars}
            classes={classes}
            preSelection
            close={()=>closeAddFuelOrder()}
            onChange={(record)=>{
              closeAddFuelOrder();
              handleSendOrderClick(record);
            }}
          />
        :
          <></>
      }
      {sendFuelDialogStates.showDialog
        ?
          <SendFuelOrderDialog
            dialogStates={sendFuelDialogStates}
            SystemData={SystemData}
            extraKeys={extraKeys}
            formatChars={formatChars}
            classes={classes}
            close={()=>closeSendFuelOrder()}
          />
        :
          <></>
      }
      {confirmFlightSelection.showDialog
        ?
          <MultiFlightSelectDialog
            classes={classes}
            systemData={SystemData}
            formatChars={formatChars}
            airportCode={confirmFlightSelection.airportCode}
            fromDate={moment.utc().format("YYYY-MM-DD")}
            lines={confirmFlightSelection.flights}
            preSelection
            onChange={(orderLines, fuelPolicy, fuelSupplier, supplyDetails)=>{
              const lines = [...orderLines];
              if (orderLines && Array.isArray(orderLines)) {
                orderLines.forEach(line => {
                  if (__.find(lines, {tripLegUuid: line.tripLegUuid}) === undefined)
                    lines.push(line);
                  if (!fuelPolicy)
                    fuelPolicy = line.fuelPolicy;
                  if (fuelPolicy !== line.fuelPolicy)
                    fuelPolicy = "VARIOUS";
                });
              }
              handlePreSelectedFlights(lines, fuelPolicy, fuelSupplier, supplyDetails);
              setConfirmFlightSelection({
                showDialog: false,
                flights: {},
                airportCode: "",
                title: 'Confirm Flight Selection'
              });
            }}
          />
        :
          <></>
      }

    </div>
  );

}

export default FlightsMissingFuelOrdersList;
